var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntSpecialistIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 7.69109C8.23842 -5.24206 23.1632 2.82155 18.0224 12.9561C17.0803 14.8132 16.0366 16.847 16.6745 18.8294C16.7428 19.0414 16.8199 19.2527 16.9069 19.4673C17.1955 20.1791 16.7129 21 15.9448 21H9.75738C9.39599 21 9.06959 20.8033 8.8924 20.4884C8.75903 20.2513 8.59942 19.9944 8.38002 19.7358C7.95181 19.2311 7.22661 19.2109 6.58806 19.3851C5.58159 19.6597 4.67663 19.641 4.08886 19.3051C3.44347 18.9363 3.33867 18.2493 3.67209 17.1657C3.80033 16.7489 3.75472 16.1267 3.08789 15.321",
    stroke: "#00E500",
    strokeWidth: 1.68793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.59476 14.3325C1.53943 13.8619 1.22447 13.4139 1.14438 13.1361C0.857336 12.1403 2.61757 11.262 3.95064 9.99641C4.16905 9.73811 4.22767 9.4718 4.2007 8.74609",
    stroke: "#0052FD",
    strokeWidth: 1.68793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1007 19.2249C10.3387 14.9618 7.85273 12.9928 5.03496 13.2972C4.64571 13.3392 4.58774 13.8577 4.723 14.2251C4.80285 14.442 4.81054 14.6903 4.75942 14.9936C4.69878 15.3534 5.02287 15.7052 5.38728 15.6875C7.3389 15.5931 9.66134 16.9665 11.2362 19.6047C11.3194 19.744 11.4687 19.8322 11.631 19.8322H11.6892C12.0041 19.8322 12.2209 19.5159 12.1007 19.2249Z",
    fill: "#0052FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6465 9.4967C12.6465 6.02359 17.0087 7.21834 15.7028 10.3302C15.5333 10.7341 14.9401 11.3558 14.7205 12.2924C14.5891 12.8527 14.2919 13.4984 13.7181 13.4537C13.6896 13.4515 13.6611 13.4483 13.6323 13.4443C13.2216 13.387 12.8899 13.0079 12.9515 12.5978C12.9725 12.4581 13.0182 12.3129 13.091 12.1362",
    stroke: "#0052FD",
    strokeWidth: 1.68793,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntSpecialistIcon);
export default __webpack_public_path__ + "static/media/ENTSpecialistIcon.fc904928b05a4b4a7ea88866a0098ac6.svg";
export { ForwardRef as ReactComponent };